import React, { Suspense, useRef } from "react";
import { Helmet } from "react-helmet";
// @ts-expect-error
import portraitAlexanderBreitwieser from "../assets/kontakt/Alexander_Breitwieser.jpg";
// @ts-expect-error
import portraitPeterMoll from "../assets/kontakt/Peter_Moll.jpg"
// @ts-expect-error
import portraitSebastianKrammer from "../assets/kontakt/Sebastian_Krammer.jpg"
// @ts-expect-error
import portraitMaximilianSchumacher from "../assets/kontakt/Maximilian_Schumacher.jpg"

//  import portrait from "../assets/kontakt/mathias_test.png";
import Spacer from "../components/Spacer";
import useIntersectionObserver from "../hooks/useInteractionObserver";
import "./KontaktPage.scss";
import ETypeOfPartnership from "../types/enum/type-of-partnerships";

const MultiMap = React.lazy(() => import("../components/map/MultiMap"));

const KontaktPage = () => {
	const mapsSection = useRef(null);
	const isMapsSectionVisible = useIntersectionObserver(mapsSection);

	return (
		<div>
			<Helmet>
				<title>Radl-Händler & Bike-Fachhändler | FIRMENRADL</title>
				{/* TODO: no copy */}
				<meta name="description" content="Kontaktiere uns!" />
				<meta name="theme-color" content="#474395" />

				<meta property="og:title" content="Kontakt | FIRMENRADL Bike-Leasing" />
				<meta
					property="og:image"
					content="img/assets/mood_blue_full.jpg?w=512"
				/>
				{/* TODO: no copy */}
				<meta property="og:description" content="Kontaktiere uns!" />
			</Helmet>

			<section className="kontakt-section">
				<h2>
					Für allgemeine Fragen wende dich bitte an{" "}
					<a href="mailto:office@firmenradl.at">office@firmenradl.at</a> oder
					telefonisch an <a href="tel:+43800201909">0800 201909</a>!
				</h2>
			</section>

			<Spacer />

			<section className="kontakt-section">
				<h2>Geschäftsleiter</h2>
				<KontaktCard
					image={portraitPeterMoll}
					name="Peter Moll"
					phoneNumber="+43 664 2680602"
					location=""
					email="peter.moll@intersport.at"
				/>
			</section>

			<section className="kontakt-section">
				<h2>Außendienstmitarbeiter</h2>
				<div className="kontakt-grid">

					<KontaktCard
						image={portraitAlexanderBreitwieser}
						name="Alexander Breitwieser"
						phoneNumber="+43 664 88850624"
						location="Salzburg, Oberösterreich, Steiermark, Tirol & Vorarlberg"
						email="alexander.breitwieser@intersport.at"
					/>
					<KontaktCard
						image={portraitSebastianKrammer}
						name="Sebastian Krammer"
						phoneNumber="+43 664 8505371"
						location="Wien, Burgenland, Niederösterreich & Kärnten"
						email="sebastian.krammer@intersport.at"
					/>
				</div>
			</section>
			<section className="kontakt-section">
				<h2>Verwertung</h2>
				<KontaktCard
					image={portraitMaximilianSchumacher}
					name="Maximilian Schumacher"
					phoneNumber="+43 664 2680954"
					location=""
					email="maximilian.schumacher@intersport.at"
				/>
			</section>
			<Spacer />
			<section className="suspenseSection multiMapSection" ref={mapsSection}>
				{isMapsSectionVisible && (
					<Suspense
						fallback={<div className="suspenseFallback">Loading...</div>}
					>
						<MultiMap type={ETypeOfPartnership.all} hideBanner={true} />
					</Suspense>
				)}
			</section>
		</div>
	);
};

export default KontaktPage;

type Props = {
	image: string;
	name: string;
	phoneNumber: string;
	location: string;
	email: string;
};

function KontaktCard({ image, name, phoneNumber, location, email }: Props) {
	return (
		<div className="kontakt-card">
			<img src={image} alt={`Portrait ${name}`} />
			<div>
				<h3>{name}</h3>
				<p>
					<a href={`tel:${phoneNumber}`}>{phoneNumber}</a> <br />
					{location} <br />
					<a href={`mailto:${email}`}>{email}</a>
				</p>
			</div>
		</div>
	);
}
